import { callApi, getUrlParameter, updatePageTitle } from '../utils';
import {
  closeAllModals,
  openPasswordModal,
  openRefModal,
} from '../actions/modalActions';
// import { pageView } from '../livechat';
import { closeNav, openNav } from '../actions/navActions';

import A from '../analytics';
import React from 'react';
import { closeAllPopups } from '../actions/popupActions';
import { closePaymentWindow } from '../payments';
import { connect } from 'react-redux';
import { logout } from '../actions/authActions';
import { updateUser } from '../actions/userActions';
import { withRouter } from 'react-router-dom';

// This component renders nothing and is just a utility with access to Router events and Redux store
// Used to dispatch programmatic actions on the App during state changes
class UtilsComponent extends React.Component {
  componentDidCatch(err) {
    console.error(err);
  }

  componentWillMount() {
    this.checkAuth();
    this.closeModals();
    this.initRouteActions();
    this.logAppVersion();
    this.startNavListener();
    this.logNetworkSpeed();
  }

  componentWillUnmount() {
    this.stopNavListener();
  }

  shouldComponentUpdate() {
    return false;
  }

  startNavListener() {
    document.addEventListener('click', this.handleNavLink);
  }

  stopNavListener() {
    document.removeEventListener('click', this.handleNavLink);
  }

  handleNavLink = (e) => {
    if (e.target.classList.contains('noClose')) return () => {};
    if (e.target.closest('#appNav') && !this.props.nav.open) {
      return this.openNav();
    }
    return this.closeNav();
  };

  openNav() {
    this.props.dispatch(openNav());
  }

  closeNav() {
    this.props.dispatch(closeNav());
  }

  closeModals() {
    this.props.dispatch(closeAllModals());
  }

  logAppVersion() {
    A.logAction('VERSION', process.env.REACT_APP_VERSION_TIME);
  }

  checkAuth() {
    callApi('/me')
      .then((res) => res)
      .catch((err) => {
        if (err.status === 401 && this.props.auth.authenticated) {
          this.props.dispatch(logout(false));
        }
      });
  }

  closeAllPopups() {
    this.props.dispatch(closeAllPopups());
  }

  logNetworkSpeed() {
    if (window.navigator.connection) {
      const { effectiveType, downlink } = window.navigator.connection;
      A.logAction('SPEED', effectiveType, downlink, 'NETWORK');
    }
  }

  initRouteActions() {
    // On Initial Page load
    let { pathname = '', search = '' } = this.props.location;
    updatePageTitle(pathname);
    A.view(pathname + search);
    this.closeNav();

    // Send request to activate referrer cookie
    const refId = getUrlParameter('ref', search);
    if (refId.length > 8) return;
    if (refId) {
      callApi(window.location.origin + '/me?ref=' + refId)
        .then((res) => res)
        .catch((err) => err);
    }

    this.openPasswordModal(pathname);

    // On subsequent route changes, listen for route change event
    let prevLocation = '/';
    this.props.history.listen(({ pathname, search = '' }, action) => {
      // Close Navigation Bar
      this.closeNav();

      // Run nav experiment
      this.runNavExperiment(pathname);

      // Update page title
      updatePageTitle(pathname);

      // this.closePaymentWindow();

      // Analytics: Log page load
      if (pathname !== prevLocation) {
        A.view(pathname);
        prevLocation = pathname;
      }

      // Do other route actions here
      this.getUserDetails(pathname);

      this.showInstallPrompt(pathname);

      this.showRefModal(pathname);

      this.lazyLoadImages();

      this.doChatActions(pathname);

      this.openPasswordModal(pathname);
    });
  }

  runNavExperiment(pathname) {
    // CREATE ORDER EXPERIMENTS GO HERE
  }

  openPasswordModal(path) {
    setTimeout(() => {
      if (!this.props.auth.authenticated) return;
      // Open modal on user status of 0
      if (
        this.props.user.status !== null &&
        Number(this.props.user.status) === 0
      ) {
        return this.props.dispatch(openPasswordModal());
      }

      // Open modal on user status of null and authenticated pages with exception of order routes
      if (
        path !== '/' &&
        path.indexOf('order') < 0 &&
        this.props.user.status === null
      ) {
        return this.props.dispatch(openPasswordModal());
      }
    }, 200);
  }

  doChatActions(path) {
    // pageView(path);
  }

  lazyLoadImages() {
    setTimeout(() => {
      try {
        window.ll && window.ll.update();
      } catch (err) {}
    }, 500);
  }

  showRefModal(path) {
    if (path === '/share') {
      setTimeout(() => this.props.dispatch(openRefModal()), 500);
    }
  }

  showInstallPrompt(path) {
    if (path === '/order/complete' && window.deferredPrompt) {
      setTimeout(() => {
        if (typeof window.deferredPrompt.prompt === 'function') {
          window.deferredPrompt
            .prompt()
            .then((result) => {
              // Check if userChoice is available before using it
              if (result && result.userChoice) {
                // Analytics: Log App install outcome
                A.event({
                  category: 'INSTALL',
                  action: result.outcome,
                });
              }
              window.deferredPrompt = null;
            })
            .catch((error) => {
              // Handle any errors that might occur during prompting
              console.error('Error during prompt:', error);
            });
        } else {
          console.error('Prompt method is not supported.');
        }
      }, 3000);
    }
  }

  getUserDetails(path) {
    if (['/order/create', '/order/review', '/transactions'].includes(path)) {
      let a = setTimeout(() => {
        // Get User Details && Meter History
        callApi('/user/details')
          .then(({ meterHistory = [], user = {} }) => {
            this.props.dispatch(updateUser({ meterHistory, ...user }));
            clearTimeout(a);
            a = null;
            if (user.email) {
              A.criteoEmail(user.email);
            }
          })
          .catch((err) => err);

        // Get Unviewed Tokens
        callApi('/token/unviewed')
          .then((res) => {
            this.props.dispatch(
              updateUser({ unviewedTokens: res.transactions || [] })
            );
          })
          .catch((err) => err);
      }, 500);
    }
  }

  closePaymentWindow() {
    return closePaymentWindow();
  }

  render() {
    return null;
  }
}

export default withRouter(connect((state) => ({ ...state }))(UtilsComponent));



// WEBPACK FOOTER //
// ./src/components/UtilsComponent.js